/**
 * ZOOMstudio One-Click actions (Sell Sheet + Virtual Sample) for the product
 * page. Calls this store's App Proxy (/apps/zoomstudio/...), which Shopify
 * forwards server-side to storm-creek-zoomstudio with a signed request - no
 * secret lives in this file, by design (see main-product-zoomstudio-actions.liquid).
 */
(function () {
  const PROXY_BASE = '/apps/zoomstudio';

  document.querySelectorAll('[data-zoomstudio-actions]').forEach((container) => {
    const partId = container.dataset.partId;
    const loggedIn = container.dataset.customerLoggedIn === 'true';
    const customerEmail = container.dataset.customerEmail;
    const loginUrl = container.dataset.loginUrl;
    const message = container.querySelector('[data-zoomstudio-message]');

    container.querySelectorAll('[data-zoomstudio-action]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (!loggedIn) {
          window.location.href = loginUrl;
          return;
        }

        const action = button.dataset.zoomstudioAction;
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Preparing…';
        if (message) {
          message.hidden = true;
        }
const newTab = window.open('', '_blank');
        try {
          const path = action === 'virtual-sample' ? '/designs/virtual-sample' : '/designs/sell-sheet';
          const body =
            action === 'virtual-sample'
              ? { customer_email: customerEmail, part_id: partId }
              : { customer_email: customerEmail, part_ids: [partId] };

          const response = await fetch(PROXY_BASE + path, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error('HTTP ' + response.status);
          }

          const data = await response.json();
          if (newTab) {
  newTab.location.href = data.edit_sso_url;
} else {
  window.location.href = data.edit_sso_url;
}
button.disabled = false;
button.textContent = originalText;
        } catch (err) {
          if (newTab) {
  newTab.close();
}
          if (message) {
            message.hidden = false;
            message.textContent = 'Something went wrong creating your design. Please try again.';
          }
          button.disabled = false;
          button.textContent = originalText;
        }
      });
    });
  });
})();